import React from 'react'

const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}

export const MenuIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M4 6h16M4 12h16M4 18h16" /></svg>
)

export const SearchIcon = (props) => (
  <svg {...svgProps} {...props}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
)

export const BellIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" /><path d="M10 21h4" /></svg>
)

export const CalendarIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M4 4h16v16H4z" /><path d="M8 2v4M16 2v4M4 9h16" /></svg>
)

export const PlusIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M12 5v14M5 12h14" /></svg>
)

export const StatFileIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M8 13h8M8 17h5" /></svg>
)

export const StatClockIcon = (props) => (
  <svg {...svgProps} {...props}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
)

export const StatCheckIcon = (props) => (
  <svg {...svgProps} {...props}><path d="m4 12 5 5L20 6" /></svg>
)

export const StatChartIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M4 19V5M4 19h16" /><path d="m7 15 4-4 3 2 5-6" /></svg>
)

export const MoreDotsIcon = (props) => (
  <span style={{ fontSize: 18, lineHeight: 1, color: '#84908b' }} {...props}>⋮</span>
)

export const AddManuscriptIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M12 5v14M5 12h14" /></svg>
)

export const AssignReviewerIcon = (props) => (
  <svg {...svgProps} {...props}><circle cx="12" cy="8" r="4" /><path d="M4 21v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2" /></svg>
)

export const CreateIssueIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" /></svg>
)

export const ExportReportIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M4 19V5M4 19h16" /><path d="m7 15 4-4 3 2 5-6" /></svg>
)
